/* eslint-disable */
import createIcon from '../createIcon';

const IconCloseOutlined = createIcon({
  name: 'icon-close-outlined',
  content: '<path d="M174.851 804.799l630.84-630.84 45.051 45.05-630.84 630.84z"/><path d="M805.436 849.786l-630.84-630.84 45.051-45.05 630.84 630.84z"/>',
  width: 1024,
  height: 1024
});
export default IconCloseOutlined;
